// JQ4-45 · US-AUDIT-005 — isValidUuid
//
// Client-side UUID format check for the actor filter. The actor field is free
// text; without this gate, every partial keystroke would change the query key
// and hit the server's `z.string().uuid()` validation, returning HTTP 400 on
// each character. We only trigger the query once a complete, valid UUID is typed.
// The server remains the authoritative validator.

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUuid(value: string): boolean {
  return UUID_RE.test(value);
}
